:host {
  visibility: hidden;
  width: 100%;
  opacity: 0;
  transform: scaleY(0);
}

:host(.open) {
  visibility: visible;
  opacity: 1;
  transform: scaleY(1);
  transform-origin: top;
  transition:
    transform 0.2s,
    opacity 0.2s;
  transition-timing-function: cubic-bezier(0.55, 0.085, 0.32, 1);
}
